import { React, Columns, Button } from "xolabot-sdk";
import { AbstractAddon } from "./AbstractAddon";

const buttonStyle = {
    borderRadius: 0,
    width: "50%",
    textTransform: "uppercase",
};
const cancelButtonStyle = {
    background: "#ccc",
    borderColor: "#ccc",
    color: "black",
    borderRadius: 0,
    width: "50%",
};
const wrapperButtonStyle = {
    marginBottom: -24,
    marginLeft: -24,
    marginRight: -24,
};

const ModalBody = ({ addons, onCancelClick, onAddToCartClick, description }) => {
    return (
        <div style={{ marginBottom: -24 }}>
            {description ? <p>{description}</p> : null}
            <Columns style={{ marginBottom: 20 }}>
                {addons.map((addon, index) => (
                    <AbstractAddon key={index} addon={addon} />
                ))}
            </Columns>
            <div style={wrapperButtonStyle}>
                <Button style={{ ...buttonStyle, ...cancelButtonStyle }} onClick={onCancelClick}>
                    No thanks
                </Button>
                <Button style={buttonStyle} onClick={onAddToCartClick}>
                    Add to cart
                </Button>
            </div>
        </div>
    );
};

export default ModalBody;
